import React from "react";
import registrationStepsReducer, {defaultState} from "./registration-steps-reducer";
import actions from "./registration-steps";

const RegistrationStepsContext = React.createContext();

function useRegistrationStepsContextValue() {
    const [state, dispatch] = React.useReducer(registrationStepsReducer, defaultState);

    const {step, selectedSubscription, user, emailVerified, registrationError, amount} = state;

    const setStep = React.useCallback((step) => dispatch(actions.setStep(step)), []);
    const selectSubscription = React.useCallback((subscription) => dispatch(actions.selectSubscription(subscription)), []);
    const loadUser = React.useCallback((user) => dispatch(actions.loadUser(user)), []);
    const setEmailVerified = React.useCallback((status) => dispatch(actions.setEmailVerified(status)), []);
    const setRegistrationError = React.useCallback((message) => dispatch(actions.setRegistrationError(message)), []);
    const setAmount = React.useCallback((amount) => dispatch(actions.setAmount(amount)), []);

    return React.useMemo(() => {
        return {
            state,
            step, setStep,
            selectedSubscription, selectSubscription,
            user, loadUser,
            emailVerified, setEmailVerified,
            registrationError, setRegistrationError,
            amount, setAmount,
        }
    }, [
        state,
        step, setStep,
        selectedSubscription, selectSubscription,
        user, loadUser,
        emailVerified, setEmailVerified,
        registrationError, setRegistrationError,
        amount, setAmount,
    ]);
}

function RegistrationStepsProvider(props) {
    const value = useRegistrationStepsContextValue();
    return <RegistrationStepsContext.Provider value={value} {...props} />
}

function useRegistrationSteps() {
    const context = React.useContext(RegistrationStepsContext);
    if (!context) {
        throw new Error("useRegistrationSteps must be used within a RegistrationStepsProvider");
    }
    return context;
}

export {
    useRegistrationSteps,
    RegistrationStepsProvider,
}